import isDebug from '../isDebug/isDebug';
/**
 * @function loog
 * @desc If debug mode is enabled, it logs to the console.
 *
 * @param {String} msg - the message to log.
 * @param {String} [status] - the log level status.
 * @param {Any} [data] - additional logging data.
 */
export default function loog(
  msg: string,
  status: string = 'info',
  data?: any
): void {
  if (isDebug()) {
    if (
      msg !== '' &&
      status !== '' &&
      window.log !== null &&
      window.log[status] !== undefined
    ) {
      if (data !== undefined) window.log[status](msg, data);
      else window.log[status](msg);
    }
  }
}
